import React from 'react';
import styled from 'styled-components';

const TestimonialsSection = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: #6a1b9a;
  font-size: 36px;
  margin-bottom: 15px;
`;

const SectionSubtitle = styled.p`
  text-align: center;
  color: #666;
  font-size: 18px;
  margin-bottom: 50px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
`;

const Divider = styled.div`
  height: 4px;
  width: 80px;
  background: linear-gradient(to right, #00b8d4, #6a1b9a);
  margin: 0 auto 40px;
`;

const TestimonialsContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const TestimonialGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 30px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const TestimonialCard = styled.div`
  background-color: #f8f2ff;
  border-radius: 10px;
  padding: 30px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  transition: transform 0.3s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const TestimonialContent = styled.p`
  color: #555;
  font-size: 16px;
  line-height: 1.8;
  font-style: italic;
  margin-bottom: 20px;
  position: relative;
  
  &::before {
    content: '"';
    font-size: 60px;
    color: #e1bee7;
    position: absolute;
    top: -20px;
    left: -15px;
    opacity: 0.5;
  }
`;

const TestimonialAuthor = styled.div`
  display: flex;
  align-items: center;
`;

const AuthorImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 15px;
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const AuthorInfo = styled.div``;

const AuthorName = styled.h4`
  color: #6a1b9a;
  font-size: 18px;
  margin: 0 0 5px;
`;

const AuthorRelation = styled.p`
  color: #888;
  font-size: 14px;
  margin: 0;
`;

const Testimonials = () => {
  const testimonials = [
    {
      id: 1,
      content: 'Minha filha sempre teve medo de ir ao dentista, mas desde que começamos a frequentar o Ateliê Dentinhos de Leite, ela pede para voltar! O ambiente lúdico e o carinho da equipe transformaram completamente a experiência.',
      author: 'Ana Paula',
      relation: 'Mãe da Sophia, 5 anos',
      image: '/testimonials/parent1.jpg'
    },
    {
      id: 2,
      content: 'Excelente atendimento! Os profissionais são extremamente pacientes e carinhosos com as crianças. Meu filho se sente em casa e não tem mais medo de ir ao dentista. Recomendo a todos os pais!',
      author: 'Carlos Eduardo',
      relation: 'Pai do Pedro, 7 anos',
      image: '/testimonials/parent2.jpg'
    },
    {
      id: 3,
      content: 'O diferencial do Ateliê Dentinhos de Leite é a atenção individualizada. Eles realmente entendem as necessidades específicas de cada criança e sabem como lidar com os pequenos. Minha filha adora ir!',
      author: 'Fernanda Silva',
      relation: 'Mãe da Laura, 4 anos',
      image: '/testimonials/parent3.jpg'
    },
    {
      id: 4,
      content: 'Encontramos no Ateliê Dentinhos de Leite profissionais que realmente sabem como transformar a ida ao dentista em uma experiência positiva. A estrutura é incrível e pensada nos mínimos detalhes para o conforto das crianças.',
      author: 'Marcelo Alves',
      relation: 'Pai do Lucas, 6 anos',
      image: '/testimonials/parent4.jpg'
    }
  ];

  return (
    <TestimonialsSection id="depoimentos">
      <SectionTitle>Depoimentos</SectionTitle>
      <SectionSubtitle>
        O que os pais e responsáveis dizem sobre o Ateliê Dentinhos de Leite
      </SectionSubtitle>
      <Divider />
      
      <TestimonialsContainer>
        <TestimonialGrid>
          {testimonials.map(testimonial => (
            <TestimonialCard key={testimonial.id}>
              <TestimonialContent>
                {testimonial.content}
              </TestimonialContent>
              <TestimonialAuthor>
                <AuthorImage>
                  <img src={testimonial.image} alt={testimonial.author} />
                </AuthorImage>
                <AuthorInfo>
                  <AuthorName>{testimonial.author}</AuthorName>
                  <AuthorRelation>{testimonial.relation}</AuthorRelation>
                </AuthorInfo>
              </TestimonialAuthor>
            </TestimonialCard>
          ))}
        </TestimonialGrid>
      </TestimonialsContainer>
    </TestimonialsSection>
  );
};

export default Testimonials;
